import React from "react";
import { OTSubscriber } from "opentok-react";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import Avatar from "react-avatar";
import ReactDOM from "react-dom";

import * as actions from "../../../../store/actions";
import StartCallIcon from "../../../../components/uiElements/icons/profileIcons/StartCallIcon";

class Subscriber extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: null,
      audio: true,
      video: true,
      subscriber: null,
      mic: true,
      sourceVideo: true,
    };
    this.otSubscriber = React.createRef();
  }

  setAudio = audio => {
    this.setState({ audio });
  };

  setVideo = video => {
    this.setState({ video });
  };

  setMic = mic => {
    this.setState({ mic }, () => {
      const ele = document
        ?.getElementById(this.otSubscriber.current.getSubscriber()?.id)
        ?.getElementsByClassName("OT_name")[0];

      ReactDOM.render(
        <>
          {this.otSubscriber.current.getSubscriber()?.stream?.name}{" "}
          {!this.state.mic && (
            <span className="mic-off ml-2 p-1">
              <StartCallIcon type="micOff" initial />
            </span>
          )}
        </>,
        ele
      );
    });
  };

  setSourceVideo = sourceVideo => {
    this.setState({ sourceVideo });
  };

  onError = err => {
    this.setState({ error: `Failed to subscribe: ${err.message}` });
  };

  onSuccessScreenshot = imgData => {
    this.props.setScreenshots(imgData);
    !this.props.control?.notes &&
      toast.dark("Please select notes to save screenshot", {
        position: toast.POSITION.BOTTOM_RIGHT,
        bodyStyle: {
          marginBottom: 100,
          height: "max-height",
          boxShadow: "none",
          backgroundColor: "#000000",
          opacity: 0.8,
          backdropFilter: "blur(10px)",
          borderRadius: "50px 0px 0px 50px",
          paddingLeft: 20,
        },
        autoClose: 3000,
      });
  };

  componentDidMount() {
    this.getSubscriber();
  }

  getSubscriber() {
    if (this.otSubscriber) {
      this.setState({
        subscriber: this.otSubscriber.current.getSubscriber(),
      });
    }
  }

  renderProfileImage() {
    const ele = document
      ?.getElementById(this.otSubscriber.current.getSubscriber()?.id)
      ?.getElementsByClassName("OT_widget-container")[0]
      ?.getElementsByClassName("OT_video-poster")[0];
    ReactDOM.render(
      <div className="center-element">
        <Avatar
          src={
            this.props.users.find(
              user =>
                user.streamId ===
                this.otSubscriber.current.getSubscriber()?.streamId
            )?.image
          }
          name={this.otSubscriber?.current?.getSubscriber()?.stream?.name}
          size={200}
          round={true}
          maxInitials={2}
        />{" "}
      </div>,
      ele
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.control?.takeScreenshot !== this.props.control?.takeScreenshot
    ) {
      let subscriberImage = this.otSubscriber.current
        ?.getSubscriber()
        ?.getImgData();

      if (
        this.state.video &&
        this.state.sourceVideo &&
        subscriberImage &&
        this.props.users.find(
          user =>
            user.streamId ===
              this.otSubscriber.current.getSubscriber()?.streamId &&
            !["GUEST_PHYSICIAN", "MAIN_PHYSICIAN"].includes(user.type)
        )
      ) {
        let imgData = "data:image/png;base64," + subscriberImage;

        !this.props.control?.notes
          ? toast.dark(
              <img
                src={imgData}
                style={{
                  width: "60%",
                  height: "60%",
                }}
                alt="screenshot"
              />,
              {
                position: toast.POSITION.BOTTOM_RIGHT,
                bodyStyle: {
                  background: "none",
                },
                autoClose: 5000,
                closeButton: false,
                onClose: () => {
                  this.onSuccessScreenshot(imgData);
                },
              }
            )
          : this.onSuccessScreenshot(imgData);
      }
    }

    if (prevProps.stream_changed !== this.props.stream_changed) {
      if (
        Object.keys(this.props.stream_changed).includes(
          this.otSubscriber.current?.state?.stream?.id
        )
      ) {
        const streamChanged =
          this.props.stream_changed[
            this.otSubscriber.current?.state?.stream?.id
          ];

        if ("hasAudio" in streamChanged) {
          this.setMic(streamChanged?.hasAudio);
        }

        if ("hasVideo" in streamChanged) {
          this.setSourceVideo(streamChanged?.hasVideo);
        }
      }
    }

    if (prevProps.users !== this.props.users) {
      this.renderProfileImage();
    }
  }

  render() {
    return (
      <div>
        {this.state.error ? <div id="error">{this.state.error}</div> : null}

        <OTSubscriber
          stream={this.props.stream}
          ref={this.otSubscriber}
          properties={{
            subscribeToAudio: this.state.audio,
            subscribeToVideo: this.state.video,
            insertMode: "append",
            showControls: true,
            fitMode: "contain",
            height: "100%",
            width: "100%",
            style: {
              nameDisplayMode: "on",
              audioLevelDisplayMode: "off",
              audioBlockedDisplayMode: "on",
              buttonDisplayMode: "on",
              backgroundImageURI: "undefined",
            },
          }}
          onError={this.onError}
        />
        {(!this.state.sourceVideo || !this.state.video) && (
          <div className="OT_video-poster">
            <Avatar
              src={this.props?.profileImage}
              name={this.otSubscriber.current?.getSubscriber()?.stream?.name}
              size={200}
              round={true}
              maxInitials={2}
            />
          </div>
        )}
      </div>
    );
  }
}
const mapStoreToProps = ({ dashboard }) => ({
  control: dashboard.appointments?.control,
  users: dashboard.ongoingAppointment?.users,
});

const mapDispatchToProps = dispatch => ({
  changeControl: control => dispatch(actions.changeControl(control)),
  setScreenshots: url => dispatch(actions.setScreenshots(url)),
});

export default connect(mapStoreToProps, mapDispatchToProps)(Subscriber);
